import React from 'react';

export default function Home() {
  return (

    <div className='navbar-light bg-light  main-text'>

      <div className="welcome-message">Bem-vindo ao Code User</div>

      <p>Lembre-se de:</p>
      <ul>
        <li>Selecionar seu ponto de atendimento;</li>
        <li>No menu atendimento chamar a próxima senha;</li>
        <li>Iniciar o atendimento assim que começar a interagir com o cliente;</li>
        <li>Finalizar o atendimento, não esquecendo de marcar os serviços (se existirem);</li>
        <li>E pronto :) Reinicie o ciclo!</li>
      </ul>
      </div>

  );
}
